import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Link を追加

function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'プライバシーポリシー | 旭興株式会社';
  }, []);

  // CSSの内容を文字列として定義
  const privacyPolicyStyles = `
    .privacy-policy-body {
      font-family: "Hiragino Sans", "Noto Sans JP", sans-serif;
      line-height: 1.8;
      color: #333;
      background-color: #fafafa;
      min-height: 100vh;
    }

    .privacy-policy-header {
      background-color: #4285F4;
      color: #fff;
      padding: 2.5rem 1rem;
      text-align: center;
    }

    .privacy-policy-header h1 {
      margin: 0;
      font-size: 1.9rem;
      font-weight: 600;
      color: #fff !important;
      letter-spacing: 0.05em;
    }

    .privacy-policy-main {
      max-width: 900px;
      margin: 3rem auto;
      background-color: white;
      padding: 2rem 3rem;
      border-radius: 8px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    }

    .privacy-policy-main h2 {
      margin-top: 2.5rem;
      font-size: 1.3rem;
      border-left: 5px solid #4285F4;
      padding-left: 0.6rem;
      color: #4285F4;
    }

    .privacy-policy-main ol, .privacy-policy-main ul {
      margin-left: 2rem;
    }

    .privacy-policy-footer {
      text-align: center;
      color: #666;
      font-size: 0.9rem;
      margin: 3rem 0 0 0;
      border-top: 2px solid #4285F4;
      padding: 1rem 0 3rem 0;
    }

    @media (max-width: 600px) {
      .privacy-policy-main {
        padding: 1.5rem;
        margin: 1rem;
      }
    }

    .no-bullet {
      list-style-type: none;
      padding-left: 1rem;
      margin-top: 0.5rem;
    }

    .company-list {
      text-align: right;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }

    .back-link-container {
      text-align: right;
      margin-bottom: 1rem;
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: privacyPolicyStyles }} />
      
      <div className="privacy-policy-body">
        <header className="privacy-policy-header">
          <h1>プライバシーポリシー</h1>
        </header>

        <Container as="main" className="privacy-policy-main">
          {/* メインメニューに戻るボタンを設置 */}
          <div className="back-link-container">
            <Link to="/mainmenu">
              <small>メインメニューに戻る</small>
            </Link>
          </div>

          <p>
            旭興株式会社（以下弊社）および弊社グループ各社は、事業活動において、個人情報保護の重要性に鑑み、個人情報の保護に関する法律（個人情報保護法）、行政手続における特定の個人を識別するための番号の利用等に関する法律（番号法）、その他の関係法令、関係官庁からのガイドライン、特定個人情報の適正な取扱いに関するガイドラインなどを遵守して、個人情報を厳正・適切に取り扱うとともに、安全管理について適切な措置を講じます。<br />
            なお、この方針の内容は、適宜改定することがございますので、定期的にご確認ください ますようお願いいたします。
          </p>

          <h2>１．個人情報の利用目的</h2>
          <p>
            弊社および弊社グループ各社は、適法かつ公正な手段によって個人情報を収集いたします。また、以下の利用目的の範囲内において利用し、その目的以外での利用はいたしません。
          </p>

          <ol>
            <li>弊社および弊社グループ各社の取り扱う商品・サンプルの研究業務、企画開発業務、製造業務、受発注業務、配送業務</li>
            <li>弊社および弊社グループ各社の取り扱う内装仕上工事業、建築工事業の元請負または下請負業務</li>
            <li>弊社および弊社グループ各社へのお問い合わせ</li>
            <li>弊社および弊社グループ各社からのお問い合わせ</li>
            <li>展示会や新製品のご案内、紹介のご案内、キャンペーンやアフターサービスのご案内</li>
            <li>料金の請求などに関連する業務</li>
            <li>弊社および弊社グループ各社へご応募いただく方々へのご案内</li>
            <li>その他、弊社および弊社グループ各社の取り扱う事業に関連する業務</li>
            <li>弊社ウェブシステムにおけるお客様の利用状況の分析と、お客様により適したサービスを提供する等の目的のため</li>
          </ol>

          <p>
            また、弊社自ら個人情報を取得する場合において取り扱う個人情報の利用目的を変更する場合は、変更前の利用目的と相当の関連性を有すると合理的に認められる範囲内で行い、変更した利用目的をご本人に通知し、同意をいただきます。
          </p>

          <h2>２．安全管理措置</h2>
          <p>
            弊社および弊社グループ各社は、個人情報の盗難、紛失、改ざん及び漏えい等を防止するために適正な安全管理措置を講じ、適宜是正を行います。
          </p>

          <h2>３．個人情報の共同利用について</h2>
          <p>
            弊社は、利用目的に応じて個人情報を弊社グループ会社と共同で利用します。
          </p>

          <h2>４．個人情報の委託・第三者提供について</h2>
          <p>
            弊社および弊社グループ各社は、個人情報を利用目的に応じて外部に委託する場合は、委託先の選定にあたって十分な審査を行い、再委託を含め個人情報の安全管理が適切に行われるよう、契約による義務付けおよび監督を実施いたします。<br />
            また、次の場合を除き、あらかじめ本人の同意を得ることなく個人情報を第三者に提供することはありません。
          </p>

          <ol>
            <li>法令に基づく場合</li>
            <li>人の生命・身体または財産の保護のために必要な場合で、本人の同意を得ることが困難なとき</li>
            <li>公衆衛生の向上や児童の健全育成に特に必要な場合</li>
            <li>国・地方公共団体の法令事務に協力する場合</li>
            <li>
              以下の業務遂行上必要な範囲で、契約に基づき第三者へ提供する場合
              <ul className="no-bullet">
                <li>（１）弊社および弊社グループ各社の取り扱う商品・サンプルの研究、企画開発、製造、受発注、配送業務</li>
                <li>（２）弊社および弊社グループ会社の取り扱う内装仕上工事業、建築工事等の元請負・下請負業務</li>
                <li>（３）仕入先メーカーへの発注・製造・納品処理</li>
              </ul>
            </li>
          </ol>

          <p>
            ※外国にある事業者へ個人情報を提供する場合には、当該事業者が個人情報保護法に基づく十分な体制を有していることを確認の上、適切に管理いたします。
          </p>

          <h2>５．従業員教育について</h2>
          <p>
            弊社および弊社グループ各社は、従業員が適切に個人情報を取り扱うための教育、訓練を適宜行います。
          </p>

          <h2>６．個人情報の開示・訂正・利用停止等について</h2>
          <p>
            弊社および弊社グループ各社は、個人情報の開示・訂正・利用停止等に対し、以下の請求に基づいて適切に対応します。
          </p>
          <ol>
            <li>開示請求</li>
            <li>訂正請求</li>
            <li>利用停止請求</li>
            <li>その他請求</li>
          </ol>

          <h2>７．個人情報に関するお問い合わせについて</h2>
          <p>
            弊社および弊社グループ各社の個人情報に関するお問い合わせは以下の連絡先までお願いいたします。<br />
            弊社および弊社グループ各社は以下の通りです。
          </p>

          <p className="company-list">
            旭興株式会社<br />
            西武株式会社
          </p>

          <p>
            <strong>グループ代表窓口：</strong><br />
            旭興株式会社　総務部　TEL：06-6453-5971
          </p>

          {/* 下部にも戻るボタンがあると親切なため追加 */}
          <div className="text-center mt-5">
            <Link to="/mainmenu">メインメニューに戻る</Link>
          </div>
        </Container>

        <footer className="privacy-policy-footer">
          &copy; 旭興株式会社　西武株式会社　 All Rights Reserved.
        </footer>
      </div>
    </>
  );
}

export default PrivacyPolicy;